import { useEffect, useState } from 'react';

/**
 * Inline confirm for offboarding a member. The parent owns the API call.
 * candidates: other active members who can receive the cases.
 */
export default function OffboardDialog({ member, candidates, onConfirm, onCancel, busy }) {
    const [target, setTarget] = useState(candidates[0]?.uid ?? '');
    // Key on the uid list, not the array identity: the parent may rebuild the
    // array on every render. Keep the current pick while it is still a candidate.
    const candidateKey = candidates.map((c) => c.uid).join(',');
    useEffect(() => {
        const uids = candidateKey ? candidateKey.split(',') : [];
        setTarget((t) => (uids.includes(t) ? t : uids[0] ?? ''));
    }, [candidateKey]);
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onCancel]);
    const name = member.name || member.email || member.uid;
    const canConfirm = Boolean(target) && !busy;
    return (
        <div className="offboard-dialog" role="dialog" aria-modal="true" aria-labelledby="offboard-title">
            <h3 id="offboard-title">Offboard {name}</h3>
            <p className="offboard-copy">
                This will reassign every open case they hold, disable their sign-in immediately, and free their seat.
                Their cases stay in the agency. This cannot be undone from here.
            </p>
            {candidates.length === 0 ? (
                <p className="offboard-warning">No other member can receive their cases. Invite or promote someone first.</p>
            ) : (
                <label className="offboard-field">
                    Reassign their cases to
                    <select value={target} onChange={(e) => setTarget(e.target.value)} disabled={busy}>
                        {candidates.map((c) => <option key={c.uid} value={c.uid}>{c.name || c.email || c.uid}</option>)}
                    </select>
                </label>
            )}
            <div className="offboard-actions">
                <button type="button" className="btn btn-ghost" onClick={onCancel} disabled={busy}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={() => onConfirm(target)} disabled={!canConfirm}>Offboard</button>
            </div>
        </div>
    );
}
